module.exports = __webpack_public_path__ + "img/product3.88a01b54.png";